export default __webpack_public_path__ + "static/media/travel-chess-board.690e6578.webp";